import { render, staticRenderFns } from "./Cte.vue?vue&type=template&id=5bfe8552"
import script from "./Cte.vue?vue&type=script&lang=js"
export * from "./Cte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports